import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * CardWW2 (OverPay WW Card) API
 * Основной метод оплаты международными банковскими картами в долларах.
 * Структура эндпоинтов идентична cardww1, отличается только путь /api/cardww2/
 * и поле `cardww2` в пакетах /api/topup/.
 */

/**
 * Получить конфигурацию cardww2 (курсы и лимиты)
 */
export const fetchCardWw2Config = async () => {
  try {
    const response = await apiService.makeRequest('/api/cardww2/')

    if (response.cardww2) {
      return response.cardww2
    }

    throw new Error('Invalid response format: cardww2 config not found')
  } catch (error) {
    console.error('Error fetching CardWW2 config:', error)
    throw error
  }
}

/**
 * Получить пакеты для cardww2 из общего списка тарифов /api/topup/
 * Фильтрует только те пакеты, у которых есть поле cardww2
 */
export const fetchCardWw2Packages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.cardww2 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching CardWW2 packages:', error)
    throw error
  }
}

// Нормализация ошибок бэкенда cardww2 к единому виду
const normalizeCardWw2CreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'

  return response.error
}

/**
 * Создать платеж cardww2 по сумме в долларах
 */
export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/cardww2/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    const normalizedError = normalizeCardWw2CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW2 payment by dollars:', error)
    throw error
  }
}

/**
 * Создать платеж cardww2 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/cardww2/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardWw2CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW2 payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату cardww2 через Telegram WebApp API
 */
export const openCardWw2Payment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'CardWW2', paymentWindow)
}

export default {
  fetchCardWw2Config,
  fetchCardWw2Packages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCardWw2Payment
}
